export default function buildClient() {
    return (
        {
            margin: [0, 0, 0, 10],
            table: {
                headerRows: 1,
                widths: [150, '*', 100, 100],
                heights: ['auto', 30],
                body: [
                    [
                        {
                            text: 'Владелец',
                        },
                        {
                            text: 'Адрес',
                        },
                        {
                            text: 'Заказчик',
                        },
                        {
                            text: 'Телефон',
                        }
                    ],
                    [
                        ' ',
                        '',
                        '',
                        '',
                    ],
                ]
            }
        }
    )
}